import { extendTheme } from "@mui/joy/styles";

declare module "@mui/joy/styles" {
  interface TypographySystemOverrides {
    buttonText: true;
    buttonTextSmall: true;
    buttonTextLarge: true;
  }
}

const geekTheme = extendTheme({
  colorSchemes: {
    light: {
      palette: {
        background: {
          body: '#f4f4f4',
        },
        primary: {
          500: '#2e2d7e',
        },
      },
    }
  },
  components: {
    JoyButton: {
      styleOverrides: {
        root: {
          borderRadius: "12px",
          padding: "12px 24px",
          fontFamily: "Inter, sans-serif",
          fontSize: "16px",
          fontWeight: "500",
          textTransform: "none",
          lineHeight: 1.5,
          "&:hover": {
            backgroundColor: "#232478",
          },
          "&:disabled": {
            backgroundColor: "#2e2d7e",
            opacity: 0.7,
          },
        },
      },
    },
  },
  typography: {
    modalHeading: {
      fontFamily: "Inter",
      fontWeight: "600",
      color: "#1A1B1D",
      fontSize: "24px",
    },
    dashboardHeading: {
      fontFamily: "Inter",
      fontWeight: "600",
      color: "#1A1B1D",
      fontSize: "16px",
    },
    mediumHeading: {
      fontFamily: "Inter",
      fontWeight: "500",
      color: "#1A1B1D",
      fontSize: "16px",
    },
    description: {
      color: "#7b7f85",
      fontSize: "1rem",
      fontFamily: "Inter",
      fontWeight: "400",
    },
    label: {
      fontSize: "16px",
      color: "#1A1B1D",
      fontWeight: "500",
    },
    buttonText: {
      fontFamily: "Inter, sans-serif",
      fontSize: "16px",
      fontWeight: "500",
      textTransform: "none",
      lineHeight: 1.5,
    },
    buttonTextSmall: {
      fontFamily: "Inter, sans-serif",
      fontSize: "14px",
      fontWeight: "500",
      textTransform: "none",
      lineHeight: 1.4,
    },
    buttonTextLarge: {
      fontFamily: "Inter, sans-serif",
      fontSize: "18px",
      fontWeight: "600",
      textTransform: "none",
      lineHeight: 1.5,
    },
  },
});

export { geekTheme };
